import styled from "styled-components";
import { media } from "../../../../../utils";

export const ResultadoBlock = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.line.medium};
  padding-bottom: 12px;
  margin-bottom: 40px;
`;

export const DetalhesResultadosContainer = styled.div`
  display: block;
  justify-content: space-between;

  ${media.md()} {
    display: flex;
  }

  p {
    margin: 0;
  }
`;

export const DetalhesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;

  ${media.md()} {
    width: 55%;
    flex-wrap: nowrap;
  }
`;

export const DetalhesMobileContent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.line.medium};
  width: 100%;
  display: flex;
  padding: 10px 0;

  ${media.md()} {
    border-bottom: none;
  }
`;

export const LoteriaNumberContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 10px;

  ${media.md()} {
    width: 40%;
    padding-top: 0;
  }
`;

export const DadosContent = styled.div`
  width: 50%;

  ${media.md()} {
    width: 100%;
  }
`;

export const LoteriaNumberContent = styled.div`
  width: 100%;

  div {
    display: flex;
    justify-content: space-between;
  }
`;

export const LoteriaFederalIcon = styled.svg`
  margin: 5px 10px;

  ${media.md()} {
    margin: 5px 15px;
  }
`;

export const PremiosSorteados = styled.div`
  & > .Card__Body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const HeaderCardContainer = styled.div`
  display: flex;
`;

export const LanceLivreIcon = styled.em`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  font-size: 30px;
`;

export const ButtonInformation = styled.button`
  border: none;
  padding: 0;
  margin: 0;
  box-shadow: none;
  margin: 0 20px;
  min-width: 0px;

  &:hover:not(:disabled) {
    box-shadow: none;
  }
`;

export const PercentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TitlePercent = styled.p`
  margin: 0;
`;

export const HeaderCardContent = styled.div`
  width: 80%;
`;

export const CotasButton = styled.button`
  width: 100%;
`;

export const NovaConsultaContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const ResultNumber = styled.p`
  text-align: center;
  margin: 0 1rem 1rem 0;
  color: ${({ theme }) => theme.color.brandPrimary.medium};
`;
